/**
 * The photograph, fetched only when asked for. Each URL is a credential that lasts minutes, so
 * none is minted for a receipt nobody looks at.
 */

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ImageIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button, Notice } from "@/components/ui/Field";
import { imageUrlQuery } from "./queries";

export function ReceiptImage({ receiptId }: { receiptId: string }) {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);
  const image = useQuery({ ...imageUrlQuery(receiptId), enabled: shown });

  if (!shown) {
    return (
      <Button variant="secondary" onClick={() => setShown(true)}>
        <span className="inline-flex items-center gap-2">
          <ImageIcon className="h-5 w-5" aria-hidden />
          {t("receipts.detail.showImage")}
        </span>
      </Button>
    );
  }
  if (image.isError) return <Notice tone="error">{t("receipts.detail.imageFailed")}</Notice>;
  if (!image.data) return <p className="text-stone-500">{t("common.loading")}</p>;
  return (
    <img
      src={image.data.url}
      alt={t("receipts.detail.imageAlt")}
      className="w-full rounded-lg border border-stone-200"
    />
  );
}
